export default __webpack_public_path__ + "static/media/ike-asistencia.998f4b7b.ico";